'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SVGTextIconStyle = require('./SVGTextIconStyle');

var _SVGTextIconStyle2 = _interopRequireDefault(_SVGTextIconStyle);

var _SVGWrapper = require('./SVGWrapper');

var _SVGWrapper2 = _interopRequireDefault(_SVGWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var SVGIcon = function SVGIcon(props) {
  var wrapperProps = props.wrapperProps,
      icon = props.icon,
      innerProps = _objectWithoutProperties(props, ['wrapperProps', 'icon']);

  return _react2.default.createElement(
    _SVGWrapper2.default,
    wrapperProps,
    _react2.default.createElement(
      _SVGTextIconStyle2.default,
      innerProps,
      icon
    )
  );
};

SVGIcon.propTyes = {
  wrapperProps: _react.PropTypes.node,
  icon: _react.PropTypes.string
};

exports.default = SVGIcon;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-avatars/static-2.493/js/UIAvatarDisplay/baseStyledComponents/SVGIcon.js
// module id = 490
// module chunks = 2 3